import {reactive} from '@/plugins/compositionApi'
import {API, client} from '@/services/http'
import {setOrgSite, setShowLoginButton} from '@/composables/context'

const acquiring = reactive({
  resolved: false,
  data: {},
  loading: true,
  profile: {},
  error: null
})

const askAcquiring = () => {
  return client.get(API.ACQUIRING.INFO)
    .then(data => {
      if (data) {
        acquiring.data = data.acquiring
        acquiring.profile = data.profile
        /* setShowLoginButton(acquiring.data.productionMode) */
        setShowLoginButton(true)
        if (data.sourceId) {
            setOrgSite(data.sourceId)
        }
      }
      acquiring.resolved = true
    })
    .catch(err => acquiring.error = err)
    .finally(() => acquiring.loading = false)
}

const getAcquiring = () => acquiring

export {
  askAcquiring,
  getAcquiring
}